var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-settings layout" },
    [
      _c("m-confirm", {
        ref: "confirm",
        attrs: {
          confirm: "Удалить",
          reset: "Отменить",
          mode: "danger",
          title: "Удаление настройки таблицы",
        },
      }),
      _c("div", { staticClass: "layout-header" }, [
        _c("div", { staticClass: "layout-title" }, [
          _vm.id
            ? _c("span", [
                _vm._v(" Настройки таблицы "),
                _c("span", { staticClass: "table-name" }, [
                  _vm._v(_vm._s(_vm.settings && _vm.settings.name)),
                ]),
              ])
            : _c("span", [_vm._v("Создать настройки таблицы")]),
        ]),
        _c("div", { staticClass: "layout-header-actions" }, [
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _vm.id
                ? _c("c-button", {
                    attrs: {
                      responsive: "",
                      label: "Удалить",
                      icon: { color: "pink", icon: "trash" },
                      type: "with-icon",
                    },
                    on: { click: _vm.removeTableSettings },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-header-action" },
            [
              _c("c-button-2", {
                attrs: {
                  size: "small",
                  responsive: true,
                  icon: "back",
                  type: "with-icon",
                  label: "К настройкам",
                },
                on: { click: _vm.toTablesSettings },
              }),
            ],
            1
          ),
        ]),
      ]),
      !_vm.id
        ? _c("div", { staticClass: "table-settings__note" }, [
            _vm._v(
              " Выберите тип таблицы и настройте для неё набор столбцов, который будет отображаться по умолчанию. Также для отдельных должностей/ролей с помощью условий можно настроить свои наборы столбцов. "
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "table-settings__content" },
        [
          !_vm.id
            ? _c("table-select", {
                staticClass: "table-settings__select",
                attrs: { error: _vm.error },
                model: {
                  value: _vm.tableType,
                  callback: function ($$v) {
                    _vm.tableType = $$v
                  },
                  expression: "tableType",
                },
              })
            : _vm._e(),
          _vm.tableType
            ? _c("table-settings-form", {
                ref: "form",
                staticClass: "table-settings__form",
                attrs: { table: _vm.tableType, settings: _vm.settings },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "table-settings__actions",
              class: {
                fixed: _vm.bottomFixed,
              },
            },
            [
              _c("c-button", {
                staticClass: "table-settings__reset",
                attrs: {
                  size: "large",
                  label: "Отменить",
                  disabled: !_vm.tableType,
                },
                on: { click: _vm.reset },
              }),
              _c("c-button", {
                staticClass: "table-settings__apply",
                attrs: {
                  label: "Сохранить",
                  color: "blue",
                  size: "large",
                  disabled: !_vm.tableType,
                },
                on: { click: _vm.submit },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { ref: "observer" }),
      _c("top-button", { attrs: { root: ".layout" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }